import { trackCancelSubscription } from "@/events/profileMixpanel";
import { loadChurnkey } from "@/lib/churnkey";
import { addAlert } from "@/redux/message/messageSlice";
import { AppDispatch } from "@/redux/store";
import { getUserSelector } from "@/redux/user/userSlice";
import { CHURNKEY_APP_ID } from "@/settings";
import { useTranslation } from "@repo/shared/i18n";
import { captureMessage } from "@sentry/react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

export function CancelButton() {
  const [loading, setLoading] = useState(false);
  const { user } = useSelector(getUserSelector);
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation(["subscription", "common"]);

  const handleCancel = async () => {
    setLoading(true);
    trackCancelSubscription();
    try {
      await loadChurnkey();
      window.churnkey.init("show", {
        customerId: user.customerId,
        authHash: user.churnkeyHash,
        // subscriptionId: user.subscriptionId,
        appId: CHURNKEY_APP_ID,
        mode: "live", //"test",
        provider: "stripe",
        record: true,
      });
    } catch (error) {
      dispatch(
        addAlert({
          title: t("cancel.failedTitle"),
          description: t("cancel.failedDescription"),
          type: "error",
        }),
      );
      captureMessage(error instanceof Error ? error.message : String(error), {
        level: "error",
        extra: {
          customerId: user.customerId,
          churnkeyHash: user.churnkeyHash,
        },
        tags: { component: "cancelButton" },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleCancel}
      disabled={loading}
      className="text-dark-tertiary text-xs underline"
    >
      {loading ? t("common:loading") : t("cancel.button")}
    </button>
  );
}
